export enum SocketIoRawEvent {
    ReviewAnswerJobDone = 'reviewAnswerJobDone',
    ReviewAnswerJobSkipped = 'reviewAnswerJobSkipped',
    AiSelectedAnalysisProgress = 'aiSelectedAnalysisProgress',
    ReviewAiJobProgress = 'reviewAiJobProgress',
    AutoReplyProgress = 'autoReplyProgress',
    ReviewFeedItemChanged = 'reviewFeedItemChanged',
    ClientReviewsSyncDone = 'clientReviewsSyncDone',
    CsvExportProgress = 'csvExportProgress',
    ReviewSelectionReconcileCompleted = 'reviewSelectionReconcileCompleted',
    RuntimeReleaseChanged = 'runtimeReleaseChanged',
}
